// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-panel-premium {
  position: fixed;
  background: var(--bg-card, rgba(255, 255, 255, 0.85));
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid var(--gray-border, rgba(0, 0, 0, 0.1));
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2), 0 1px 3px rgba(0,0,0,0.1);
  width: 320px;
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.3s ease, border-color 0.3s ease;
  z-index: 999;
}

.filter-panel-premium:active {
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.25);
  cursor: grabbing !important;
}

.filter-panel-header {
  padding: 16px 20px;
  background: linear-gradient(135deg, var(--azul, #007bff) 0%, rgba(0, 86, 179, 0.85) 100%);
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  font-size: 15px;
  letter-spacing: 0.5px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  -webkit-user-select: none;
          user-select: none;
  cursor: grab;
}

.filter-panel-premium:active .filter-panel-header {
  cursor: grabbing;
}

.filter-panel-header span {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-panel-clear-btn {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #ffffff;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  cursor: pointer;
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  transition: all 0.2s ease;
}

.filter-panel-clear-btn:hover {
  background: rgba(255, 255, 255, 0.35);
  transform: scale(1.05);
}

.filter-panel-body {
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
}

.filter-field-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filter-field-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--txt-color, #444);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-left: 4px;
}

.date-row {
  display: flex;
  gap: 10px;
}

.date-col {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.filter-field-wrapper input.premium-input {
  width: 100%;
  padding: 10px 14px;
  border-radius: 10px;
  border: 1px solid var(--gray-border, #ccc);
  background: var(--bg-content, #fff);
  color: var(--txt-color, #333);
  font-size: 14px;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.filter-field-wrapper input.premium-input:focus {
  outline: none;
  border-color: var(--azul, #007bff);
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.15);
}

/* Specific styling to ensure SelectorAdmin overrides are clean */
.filter-field-wrapper .compact-select {
  border-radius: 10px !important;
  border: 1px solid var(--gray-border, #ccc) !important;
  background: var(--bg-content, #fff) !important;
}

.filter-field-wrapper .rs-picker-toggle {
  border-radius: 10px !important;
  border: 1px solid var(--gray-border, #ccc) !important;
  background: var(--bg-content, #fff) !important;
  padding: 8px 12px !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/config-components/Auditor/styles/FilterPanelAuditor.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,qDAAqD;EACrD,2BAA2B;EAC3B,mCAAmC;EACnC,wDAAwD;EACxD,mBAAmB;EACnB,qEAAqE;EACrE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,wDAAwD;EACxD,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,yFAAyF;EACzF,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,4BAA4B;EAC5B,6BAA6B;EAC7B,yBAAiB;UAAjB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,kCAA0B;UAA1B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,mCAAmC;EACnC,6BAA6B;EAC7B,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA,iEAAiE;AACjE;EACE,8BAA8B;EAC9B,qDAAqD;EACrD,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;EAC9B,qDAAqD;EACrD,8CAA8C;EAC9C,4BAA4B;AAC9B","sourcesContent":[".filter-panel-premium {\n  position: fixed;\n  background: var(--bg-card, rgba(255, 255, 255, 0.85));\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  border: 1px solid var(--gray-border, rgba(0, 0, 0, 0.1));\n  border-radius: 16px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2), 0 1px 3px rgba(0,0,0,0.1);\n  width: 320px;\n  display: flex;\n  flex-direction: column;\n  transition: box-shadow 0.3s ease, border-color 0.3s ease;\n  z-index: 999;\n}\n\n.filter-panel-premium:active {\n  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.25);\n  cursor: grabbing !important;\n}\n\n.filter-panel-header {\n  padding: 16px 20px;\n  background: linear-gradient(135deg, var(--azul, #007bff) 0%, rgba(0, 86, 179, 0.85) 100%);\n  color: #ffffff;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-weight: 500;\n  font-size: 15px;\n  letter-spacing: 0.5px;\n  border-top-left-radius: 15px;\n  border-top-right-radius: 15px;\n  user-select: none;\n  cursor: grab;\n}\n\n.filter-panel-premium:active .filter-panel-header {\n  cursor: grabbing;\n}\n\n.filter-panel-header span {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.filter-panel-clear-btn {\n  background: rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  cursor: pointer;\n  backdrop-filter: blur(4px);\n  transition: all 0.2s ease;\n}\n\n.filter-panel-clear-btn:hover {\n  background: rgba(255, 255, 255, 0.35);\n  transform: scale(1.05);\n}\n\n.filter-panel-body {\n  padding: 24px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  border-bottom-left-radius: 16px;\n  border-bottom-right-radius: 16px;\n}\n\n.filter-field-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.filter-field-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--txt-color, #444);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-left: 4px;\n}\n\n.date-row {\n  display: flex;\n  gap: 10px;\n}\n\n.date-col {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.filter-field-wrapper input.premium-input {\n  width: 100%;\n  padding: 10px 14px;\n  border-radius: 10px;\n  border: 1px solid var(--gray-border, #ccc);\n  background: var(--bg-content, #fff);\n  color: var(--txt-color, #333);\n  font-size: 14px;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n}\n\n.filter-field-wrapper input.premium-input:focus {\n  outline: none;\n  border-color: var(--azul, #007bff);\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.15);\n}\n\n/* Specific styling to ensure SelectorAdmin overrides are clean */\n.filter-field-wrapper .compact-select {\n  border-radius: 10px !important;\n  border: 1px solid var(--gray-border, #ccc) !important;\n  background: var(--bg-content, #fff) !important;\n}\n\n.filter-field-wrapper .rs-picker-toggle {\n  border-radius: 10px !important;\n  border: 1px solid var(--gray-border, #ccc) !important;\n  background: var(--bg-content, #fff) !important;\n  padding: 8px 12px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
